function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCombobox } from "downshift";
import { useCallback, useMemo, useState } from "react";
import { Form } from "sprout-ui-dom/dist/Form";
import { FilterList } from "sprout-ui-icons";
import { media } from "sprout-ui-theme";
import Fuse from "fuse.js";
import styled from "styled-components";
import { ScrollContainer as BaseScrollContainer } from "sprout-ui-dom/dist/ScrollContainer";
import { Flex } from "sprout-ui-primitives";
import LabelsDialogInput from "../LabelsDialog/LabelsDialogInput";
import AssignmentDialogUsers from "./AssignmentDialogUsers";
import useAssignMany from "./graphql/mutations/useAssignMany";
const AssignmentDialogForm = styled(Flex)`
  ${media.up("small")} {
    padding-top: 24px;
  }
`;
const ScrollContainer = styled(BaseScrollContainer)`
  ${media.up("small")} {
    padding-bottom: 24px;
  }
`;
const stateReducer = (state, actionAndChanges)=>{
    const { type , changes  } = actionAndChanges;
    if (type === useCombobox.stateChangeTypes.InputBlur) return state;
    if (type === useCombobox.stateChangeTypes.InputChange) return _objectSpread({}, changes, {
        highlightedIndex: 0
    });
    return changes;
};
const AssignmentDialogInner = (props)=>{
    const { onRequestClose , users , selectedItems  } = props;
    const [filterInputValue, setInputValue] = useState("");
    const handleInputValueChange = useCallback((changes)=>{
        if (typeof changes.inputValue === "string") setInputValue(changes.inputValue);
    }, []);
    const searcher = useMemo(()=>{
        return new Fuse(users, {
            keys: [
                "user.username",
                "user.fullName",
                "user.firstName",
                "user.lastName", 
            ],
            threshold: 0
        });
    }, [
        users
    ]);
    const items = useMemo(()=>{
        return filterInputValue.length === 0 ? users : searcher.search(filterInputValue).map(({ item  })=>item);
    }, [
        filterInputValue,
        searcher,
        users
    ]);
    const assignManyMutation = useAssignMany(useMemo(()=>users.map(({ user  })=>user), [
        users
    ]));
    const assignMany = useCallback((selectedItem, close)=>{
        const { state , user  } = selectedItem;
        assignManyMutation({
            assigneesToAdd: state !== "complete" ? [
                user.id
            ] : [],
            assigneesToRemove: state === "complete" ? [
                user.id
            ] : [],
            posts: selectedItems
        });
        if (close) onRequestClose();
    }, [
        assignManyMutation,
        onRequestClose,
        selectedItems
    ]);
    const handleChange = useCallback((changes)=>{
        const { selectedItem  } = changes;
        if (!selectedItem) return;
        assignMany(selectedItem, true);
    }, [
        assignMany
    ]);
    const { getComboboxProps , getMenuProps , getInputProps , getItemProps , reset  } = useCombobox({
        stateReducer,
        /**
       * `defaultIsOpen: true` is required, because without it, the first
       * arrow down event will trigger it to be open, instead of highlighting
       * the next item.
       */ defaultIsOpen: true,
        inputValue: filterInputValue,
        onInputValueChange: handleInputValueChange,
        initialHighlightedIndex: 0,
        items,
        itemToString: useMemo(()=>()=>"", []),
        onSelectedItemChange: handleChange
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AssignmentDialogForm, _objectSpread({
                as: Form
            }, getComboboxProps(), {
                mb: 4,
                children: /*#__PURE__*/ _jsx(LabelsDialogInput, {
                    onRequestClose: onRequestClose,
                    autoFocus: true,
                    placeholder: "Filter",
                    prependIcon: FilterList,
                    onCancel: filterInputValue ? reset : undefined,
                    getInputProps: getInputProps
                })
            })),
            /*#__PURE__*/ _jsx(ScrollContainer, _objectSpread({
                mx: -1
            }, getMenuProps(), {
                children: /*#__PURE__*/ _jsx(AssignmentDialogUsers, {
                    users: items,
                    getItemProps: getItemProps,
                    onUserChange: assignMany
                })
            }))
        ]
    });
};
export default AssignmentDialogInner;
